import { useParams } from "react-router-dom";
import React from "react";
import InvoiceContainer from '../../../../containers/Print/default/Invoice'
export const PrintInvoice = (props)=>{
    let params=useParams();
    let id=params.id;
    document.getElementById("root").setAttribute("style","overflow:hidden");
    return (
        <InvoiceContainer id={id}/>
    )
}

export default PrintInvoice;